import { extendForm, useFormContext } from "@imi/ui/hooks/useAppForm.js";
import { FilterField } from "@src/shared/components/FilterField/FilterField";
import { NumberField } from "@src/shared/components/NumberField/NumberField";

export const { useAppForm, withFieldGroup } = extendForm({
  fieldComponents: { FilterField, NumberField },
});

export const useTypedFormContext = <T>() => {
  return useFormContext() as unknown as T;
};

// Firefox doesn't submit forms on Enter from a <select>
export function selectSubmitOnEnter(
  event: React.KeyboardEvent<HTMLFormElement>,
  submitting: boolean,
) {
  if (
    event.key !== "Enter" ||
    event.defaultPrevented ||
    event.nativeEvent.isComposing ||
    !(event.target instanceof HTMLSelectElement)
  ) {
    return;
  }
  event.preventDefault();
  if (!submitting) event.currentTarget.requestSubmit();
}
